import React, { createContext, useContext, useState, useCallback } from 'react';
import { apiFetch } from './api';

const DashboardStatsContext = createContext();

export function useDashboardStats() {
  return useContext(DashboardStatsContext);
}

export function DashboardStatsProvider({ children }) {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(false);

  const refreshStats = useCallback(async () => {
    setLoading(true);
    try {
      const res = await apiFetch('/api/Mail/conteggio_giornaliero');
      if (res.ok) {
        const data = await res.json();
        setStats(data);
      }
    } catch {}
    setLoading(false);
  }, []);

  // Aggiorna all'avvio
  React.useEffect(() => { refreshStats(); }, [refreshStats]);

  return (
    <DashboardStatsContext.Provider value={{ stats, loading, refreshStats }}>
      {children}
    </DashboardStatsContext.Provider>
  );
}
